import React from 'react';
import { Button } from '../components';

class LinkGridCell extends React.Component {

    clickHandler(e) {
        if (typeof this.props.onClick === 'function') {
            this.props.onClick(e, this.props.data, this.props.rowData);
        }
    }

    renderIcon(iconClass) {
        if (typeof iconClass === 'string' && iconClass.length > 0) {
            return (
                <span className={iconClass}></span>
            )
        } else {
            return null;
        }
    }

    render () {

        return (
            <Button {...this.props} className={['component-link-grid-cell', this.props.className].join(' ')} to={this.props.data} onClick={e => this.clickHandler(e)} >
                { this.props.text || this.renderIcon(this.props.icon) || this.props.data }
            </Button>
        )
    }
}

export default LinkGridCell;



// WEBPACK FOOTER //
// ./web-app/components/link-grid-cell.jsx